<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>

    .headingsWrapper h2, h4 {
        font-family: Roboto-Medium;
        text-transform: none;
    }

    .headingsWrapper h2 {
        font-size: 1.5rem;
        color: #5F4C54;
        text-align: center;
    }

    .headingsWrapper h4 {
        font-size: 0.875rem;
        color: #7E7885;
        text-align: center;
        margin-top: 0.9375rem;
    }

    .headingsWrapper {
        overflow: hidden;
        margin-bottom: 4.625rem;
    }
</style>

<template>
    <!-- Heading component, it displays Quiz Title and Subtitle -->
    <div class="headingsWrapper">
        <h2 v-if="quizData.title && quizData.title !== ''">
            {{ quizData.title }}
        </h2>
        <h4 v-if="quizData.subTitle && quizData.subTitle !== ''">
            {{ quizData.subTitle }}
        </h4>
    </div>
</template>

<script>
export default {
    name: 'Heading',
    data() {
        return {
        };
    },
    computed: {
        quizData: function () {
            return this.$store.state.quizData;
        }
    }
};
</script>
